/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-useless-concat */


import React, { useState, useCallback, useRef, useEffect } from 'react';
import styled from 'styled-components';
import {
  MdFormatBold,
  MdFormatItalic,
  MdFormatUnderlined,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdTitle,
  MdLink,
  MdImage,
  MdVideoLibrary
} from 'react-icons/md';
import { RxStrikethrough } from "react-icons/rx"
import { RiAdvertisementFill } from "react-icons/ri";

const AD_PLACEHOLDER_SELECTOR = '[data-ad-placeholder="true"]';
const AD_PLACEHOLDER_HTML = `
  <div data-ad-placeholder="true" contenteditable="false">
    <div class="ad-placeholder-badge">PUBLICIDADE</div>
    <div class="ad-placeholder-frame">
      <div class="ad-placeholder-brand">Sua marca aqui</div>
      <div class="ad-placeholder-headline">Banner de teste</div>
      <div class="ad-placeholder-text">Visualização simulada do anúncio no aplicativo</div>
      <div class="ad-placeholder-cta">Call to Action</div>
    </div>
  </div>
`;

const normalizeHtmlForEditor = (html = '') => {
  if (!html) {
    return '';
  }

  return html
    .replace(/<ad\b[^>]*\/>/gi, AD_PLACEHOLDER_HTML)
    .replace(/<ad\b[^>]*>\s*<\/ad>/gi, AD_PLACEHOLDER_HTML);
};

const normalizeHtmlForStorage = (html = '') => {
  if (!html) {
    return '';
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  container.querySelectorAll(AD_PLACEHOLDER_SELECTOR).forEach((node) => {
    const adElement = document.createElement('ad');
    node.replaceWith(adElement);
  });

  return container.innerHTML;
};


const Container = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;

  .rs-theme-dark & {
    border-color: #444;
  }
`;

const Toolbar = styled.div`
  display: flex;
  gap: 2px;
  padding: 8px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: wrap;

  .rs-theme-dark & {
    background: #333;
    border-color: #444;
  }
`;

const ToolButton = styled.button`
  padding: 8px;
  border: none;
  background: ${(props) => (props.active ? '#3b82f6' : 'transparent')};
  color: ${(props) => (props.active ? '#fff' : '#666')};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;

  &:hover {
    background: ${(props) => (props.active ? '#3b82f6' : '#e0e0e0')};
  }

  .rs-theme-dark &:hover {
    background: ${(props) => (props.active ? '#3b82f6' : '#444')};
  }
`;

const Divider = styled.div`
  width: 1px;
  background: #ddd;
  margin: 0 8px;

  .rs-theme-dark & {
    background: #555;
  }
`;

const EditorContent = styled.div`
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  padding: 16px;
  background: #fff;

  .rs-theme-dark & {
    background: #1a1a1a;
    color: #fff;
  }

  &:focus {
    outline: none;
  }

  h1, h2, h3 {
    margin-top: 0;
  }

  p {
    margin-bottom: 12px;
  }

  ul, ol {
    margin-left: 24px;
    margin-bottom: 12px;
  }

  a {
    color: #3b82f6;
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }

  ${AD_PLACEHOLDER_SELECTOR} {
    width: 250px;
    height: 250px;
    max-width: 100%;
    margin: 16px 0;
    padding: 18px;
    border: 2px dashed #94a3b8;
    border-radius: 20px;
    background:
      radial-gradient(circle at top right, rgba(255, 255, 255, 0.9), transparent 30%),
      linear-gradient(135deg, #eff6ff 0%, #dbeafe 45%, #bfdbfe 100%);
    color: #1f2937;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    user-select: none;
    box-shadow: 0 16px 35px rgba(59, 130, 246, 0.16);
    margin-left: 0;
    margin-right: auto;
  }

  .ad-placeholder-badge {
    align-self: flex-start;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
    color: #1d4ed8;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin-bottom: 12px;
  }

  .ad-placeholder-frame {
    width: 100%;
    flex: 1;
    border-radius: 18px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    text-align: left;
    background:
      linear-gradient(160deg, rgba(37, 99, 235, 0.95) 0%, rgba(30, 64, 175, 0.92) 100%);
    color: #fff;
    position: relative;
    overflow: hidden;
  }

  .ad-placeholder-frame::after {
    content: '';
    position: absolute;
    right: -50px;
    bottom: -50px;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
  }

  .ad-placeholder-brand,
  .ad-placeholder-headline,
  .ad-placeholder-text,
  .ad-placeholder-cta {
    position: relative;
    z-index: 1;
  }

  .ad-placeholder-brand {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    opacity: 0.92;
    margin-bottom: 8px;
  }

  .ad-placeholder-headline {
    font-size: 22px;
    line-height: 1.1;
    font-weight: 800;
    margin-bottom: 10px;
    max-width: 150px;
  }

  .ad-placeholder-text {
    font-size: 12px;
    line-height: 1.35;
    opacity: 0.92;
    max-width: 150px;
    margin-bottom: 16px;
  }

  .ad-placeholder-cta {
    padding: 8px 12px;
    border-radius: 999px;
    background: #fff;
    color: #1d4ed8;
    font-size: 11px;
    font-weight: 700;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  }

  .rs-theme-dark & ${AD_PLACEHOLDER_SELECTOR} {
    background:
      radial-gradient(circle at top right, rgba(255, 255, 255, 0.08), transparent 30%),
      linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
    border-color: #6b7280;
    color: #e5e7eb;
    box-shadow: 0 16px 35px rgba(15, 23, 42, 0.5);
  }

  .rs-theme-dark & .ad-placeholder-badge {
    background: rgba(15, 23, 42, 0.55);
    color: #93c5fd;
  }

  .rs-theme-dark & .ad-placeholder-frame {
    background: linear-gradient(160deg, rgba(37, 99, 235, 0.72) 0%, rgba(30, 41, 59, 0.95) 100%);
  }
`;

const RichTextEditor = ({ value = '', onChange, placeholder = 'Digite seu conteúdo aqui...' }) => {
  const editorRef = useRef(null);
  const [activeFormats, setActiveFormats] = useState(new Set());

  // Sincronizar valor externo com o editor
  useEffect(() => {
    const normalizedValue = normalizeHtmlForEditor(value || '');

    if (editorRef.current && editorRef.current.innerHTML !== normalizedValue) {
      editorRef.current.innerHTML = normalizedValue;
    }
  }, [value]);

  const updateActiveFormats = useCallback(() => {
    const formats = new Set();
    
    if (document.queryCommandState('bold')) formats.add('bold');
    if (document.queryCommandState('italic')) formats.add('italic');
    if (document.queryCommandState('underline')) formats.add('underline');
    if (document.queryCommandState('insertUnorderedList')) formats.add('ul');
    if (document.queryCommandState('insertOrderedList')) formats.add('ol');
    if (document.queryCommandState('strikethrough')) formats.add('strikethrough');

    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      let node = selection.anchorNode;
      while (node && node !== editorRef.current) {
        if (node.nodeName === 'H1') formats.add('h1');
        if (node.nodeName === 'H2') formats.add('h2');
        if (node.nodeName === 'H3') formats.add('h3');
        node = node.parentNode;
      }
    }

    setActiveFormats(formats);
  }, []);

  const handleChange = useCallback(() => {
    const html = editorRef.current?.innerHTML || '';
    onChange(normalizeHtmlForStorage(html));
  }, [onChange]);

  const execCommand = useCallback((command, value = null) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
    updateActiveFormats();
    handleChange();
  }, [handleChange, updateActiveFormats]);

  const formatHeading = useCallback((level) => {
    document.execCommand('formatBlock', false, level);
    handleChange();
    updateActiveFormats();
  }, [handleChange, updateActiveFormats]);

  const insertLink = useCallback(() => {
    const url = prompt('Digite a URL do link:');
    if (url) {
      document.execCommand('createLink', false, url);
      handleChange();
    }
  }, [handleChange]);

  const insertImage = useCallback(() => {
    const url = prompt('Digite a URL da imagem:');
    if (url) {
      document.execCommand('insertImage', false, url);
      handleChange();
    }
  }, [handleChange]);

function converterUrlYoutubeParaEmbed(url) {
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(shorts\/)|(watch\?))\??v?=?([^#&?]*).*/;
            // const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            const match = url.match(regExp);
            // console.log(match, 'match');
            return (match && match[8].length === 11) ? `https://www.youtube.com/embed/${match[8]}` : false;
            // return (match && match[7].length === 11) ? `https://www.youtube.com/embed/${match[7]}` : false;
        }


  const insertVideo = useCallback(() => {
    const url = prompt('Digite a URL do v\u00eddeo:');

    const url2 = converterUrlYoutubeParaEmbed(url)
    if (url) {
      const videoHTML = `<iframe width="560" height="315" src="${url2}" frameborder="0" allowfullscreen></iframe>`;
      document.execCommand('insertHTML', false, videoHTML);
      handleChange();
    }
  }, [handleChange]);

  const addAnuncio = useCallback(() => {
    document.execCommand('insertHTML', false, AD_PLACEHOLDER_HTML);
    handleChange();
  }, [handleChange]);


  return (
    <Container>
      <Toolbar>
        <ToolButton
          active={activeFormats.has('bold')}
          onClick={() => execCommand('bold')}
          title="Negrito"
        >
          <MdFormatBold />
        </ToolButton>
        <ToolButton
          active={activeFormats.has('italic')}
          onClick={() => execCommand('italic')}
          title="Itálico"
        >
          <MdFormatItalic />
        </ToolButton>
        <ToolButton
          active={activeFormats.has('underline')}
          onClick={() => execCommand('underline')}
          title="Sublinhado"
        >
          <MdFormatUnderlined />
        </ToolButton>
        <ToolButton
          active={activeFormats.has('strikethrough')}
          onClick={() => execCommand('strikethrough')}
          title="Tachado"
        >
          <RxStrikethrough />
        </ToolButton>

        <Divider />

        <ToolButton
          active={activeFormats.has('h1')}
          onClick={() => formatHeading('h1')}
          title="Título 1"
        >
          H1
        </ToolButton>
        <ToolButton
          active={activeFormats.has('h2')}
          onClick={() => formatHeading('h2')}
          title="Título 2"
        >
          H2
        </ToolButton>
        <ToolButton
          active={activeFormats.has('h3')}
          onClick={() => formatHeading('h3')}
          title="Título 3"
        >
          H3
        </ToolButton>

        <Divider />

        <ToolButton
          active={activeFormats.has('ul')}
          onClick={() => execCommand('insertUnorderedList')}
          title="Lista com marcadores"
        >
          <MdFormatListBulleted />
        </ToolButton>
        <ToolButton
          active={activeFormats.has('ol')}
          onClick={() => execCommand('insertOrderedList')}
          title="Lista numerada"
        >
          <MdFormatListNumbered />
        </ToolButton>

        <Divider />

        <ToolButton onClick={insertLink} title="Inserir link">
          <MdLink />
        </ToolButton>
        <ToolButton onClick={insertImage} title="Inserir imagem">
          <MdImage />
        </ToolButton>
        <ToolButton onClick={insertVideo} title="Inserir vídeo">
          <MdVideoLibrary />
        </ToolButton>
        <ToolButton onClick={addAnuncio} title="Inserir anúncio">
          <RiAdvertisementFill />
        </ToolButton>
      </Toolbar>

      <EditorContent
        ref={editorRef}
        contentEditable
        onInput={handleChange}
        onSelect={updateActiveFormats}
        onKeyUp={updateActiveFormats}
        onMouseUp={updateActiveFormats}
        data-placeholder={placeholder}
        suppressContentEditableWarning
      />
    </Container>
  );
};

export default RichTextEditor;
